<!--  -->
<template>
  <div class="container">
     <el-carousel :interval="4000" type="card" height="525px" class="carouselc">
        <el-carousel-item  v-for="(article,index) in articles" :key="index" :style="`background-image: url('${global.remoteIp}/uploads/${article.picsrc}');`">
            
        </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        articles:[],
        global
    };
  },
  props: {
    plates:Array
  },
  mounted() {
    let strplate = "";
    for (var i = 0; i < this.plates.length; i++) {
        if(this.plates[i].name=="新闻动态"){
            strplate = this.plates[i]._id;
        }
    }
    this.$axios.get(`/api/articles?plateid=${strplate}&page=1&limit=3&sort=-createdAt`).then(res => {
        if(res.data)
        {
            this.articles=res.data.data;
            this.$nextTick(function(){
                this.installOwlCarousel()
            })
        }
    });
  },
  methods: {
      installOwlCarousel(){
          $('.homepage-slide1').owlCarousel({
            items: 1,
            nav: true,
            dots: true,
            autoplay: false,
            loop: true,
            smartSpeed: 5000,
            animateOut: 'lightSpeedOut',
            animateIn: 'fadeIn',
            active: true,
            navText: ["<i class='la la-angle-left'></i>", "<i class='la la-angle-right'></i>"],
        });
      }
  }
}
</script>
<style scoped>
/deep/ .el-carousel__item--card.is-active{
        background-repeat: no-repeat;
    background-size: cover;
    width: 840px;
}
  
/deep/ .el-carousel__item--card.is-active {
    z-index: 2;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0px) !important;
}
/deep/ .el-carousel__indicators--outside{
  display:none;
}
</style>